import {
    iconNewFacebook,
    iconNewInstagram,
    iconNewLinkedin,
    iconNewSpotify, iconNewTiktok,
    iconNewTwitter,
    iconNewYoutube
} from "../../../../assets";
import {h} from "preact";

const SocialMedia = () => {
    return (
        <div className={"flex flex-col gap-y-2"}>
            <p
                className="hidden xmd:block text-[14px] m-0"
                data-testid="network-label"
            >
                Nossas redes:
            </p>
            <div className="flex justify-center xmd:justify-between gap-1.5 xmd:gap-1">
                <a
                    href="https://www.instagram.com/sabinbr_/"
                    target="_blank"
                    data-testid="footer-instagram-link"
                    rel="noreferrer"
                >
                    <img
                        src={iconNewInstagram}
                        className="w-[36px] xmd:w-[24px]"
                        alt="s"
                    />
                </a>
                <a
                    href="https://www.facebook.com/sabindiagnosticoesaude"
                    target="_blank"
                    data-testid="footer-facebook-link"
                    rel="noreferrer"
                >
                    <img
                        src={iconNewFacebook}
                        className="w-[36px] xmd:w-[24px]"
                        alt="s"
                    />
                </a>
                <a
                    href="https://www.linkedin.com/company/sabin-medicina-diagnostica/"
                    target="_blank"
                    data-testid="footer-linkedin-link"
                    rel="noreferrer"
                >
                    <img
                        src={iconNewLinkedin}
                        className="w-[36px] xmd:w-[24px]"
                        alt="s"
                    />
                </a>
                <a
                    href="https://www.youtube.com/@sabinbr_"
                    target="_blank"
                    data-testid="footer-youtube-link"
                    rel="noreferrer"
                >
                    <img
                        src={iconNewYoutube}
                        className="w-[36px] xmd:w-[24px]"
                        alt="s"
                    />
                </a>
                <a
                    href="https://twitter.com/sabinbr_"
                    target="_blank"
                    data-testid="footer-twitter-link"
                    rel="noreferrer"
                >
                    <img
                        src={iconNewTwitter}
                        className="w-[36px] xmd:w-[24px]"
                        alt="s"
                    />
                </a>
                <a
                    href="https://open.spotify.com/user/sabinmedicinadiagnostica?si=497268219a294de5"
                    target="_blank"
                    data-testid="footer-spotify-link"
                    rel="noreferrer"
                >
                    <img
                        src={iconNewSpotify}
                        className="w-[36px] xmd:w-[24px]"
                        alt="s"
                    />
                </a>
                <a
                    href="https://www.tiktok.com/@sabinbr_"
                    target="_blank"
                    data-testid="footer-tiktok-link"
                    rel="noreferrer"
                >
                    <img
                        src={iconNewTiktok}
                        className="w-[36px] xmd:w-[24px]"
                        alt="s"
                    />
                </a>
            </div>
        </div>
    )
}

export default SocialMedia;
